import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export default ({ content }: { content: string }) => {
  return (
    <div className="max-w-none text-[13px] leading-relaxed text-slate-500">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({ children }) => <h1 className="mb-2 mt-4 text-sm font-semibold text-slate-600 first:mt-0">{children}</h1>,
          h2: ({ children }) => <h2 className="mb-2 mt-3 text-sm font-semibold text-slate-600 first:mt-0">{children}</h2>,
          h3: ({ children }) => <h3 className="mb-1.5 mt-3 text-[13px] font-semibold text-slate-600 first:mt-0">{children}</h3>,
          p: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
          strong: ({ children }) => <strong className="font-semibold text-slate-600">{children}</strong>,
          ul: ({ children }) => <ul className="mb-2 list-disc space-y-0.5 pl-4">{children}</ul>,
          ol: ({ children }) => <ol className="mb-2 list-decimal space-y-0.5 pl-4">{children}</ol>,
          li: ({ children }) => <li className="text-[13px]">{children}</li>,
          a: ({ href, children }) => (
            <a href={href} target="_blank" rel="noreferrer" className="font-medium text-indigo-500 underline underline-offset-2 hover:text-indigo-400">{children}</a>
          ),
          code: ({ children }) => (
            <code className="rounded bg-slate-100 px-1.5 py-0.5 text-[0.85em] text-slate-500">{children}</code>
          ),
          table: ({ children }) => (
            <div className="my-2 overflow-x-auto rounded-lg border border-slate-200">
              <table className="w-full border-collapse text-xs">{children}</table>
            </div>
          ),
          th: ({ children }) => <th className="bg-slate-50 px-2 py-1.5 text-left text-[11px] font-semibold text-slate-400">{children}</th>,
          td: ({ children }) => <td className="border-t border-slate-100 px-2 py-1.5 text-slate-500">{children}</td>,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};
